import { render, staticRenderFns } from "./GStudentRecordRecommendationLetterEdit.vue?vue&type=template&id=2df977ae&scoped=true&"
import script from "./GStudentRecordRecommendationLetterEdit.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordRecommendationLetterEdit.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentRecordRecommendationLetterEdit.vue?vue&type=style&index=0&id=2df977ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df977ae",
  null
  
)

export default component.exports